"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 16 16",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M7.99 12.19c-1.282 0-2.564-.003-3.846.002-.51.001-.924-.18-1.218-.6a1.423 1.423 0 0 1 .277-1.943c.214-.174.434-.345.52-.618.053-.168.093-.346.095-.52.01-.769.005-1.536.005-2.303A4.21 4.21 0 0 1 7.18 2.084c2.004-.415 4.05.741 4.75 2.686q.253.702.252 1.45c0 .746.007 1.494-.002 2.24-.006.472.165.847.544 1.126.313.231.527.529.592.916.146.874-.472 1.661-1.306 1.681-.721.018-1.444.007-2.166.008zm.02.417h1.133c.408.001.72.307.717.701-.002.388-.313.69-.717.69q-1.139.004-2.277 0c-.41 0-.722-.302-.724-.696-.001-.392.312-.694.723-.695z"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=BellAlertFillIcon16.js.map